import React from 'react';

// Centered 1200px max-width wrapper (SPEC §4). `.container` lives in global.css.
export default function Container({ as: Tag = 'div', className = '', children, ...rest }) {
  return (
    <Tag className={`container${className ? ` ${className}` : ''}`} {...rest}>
      {children}
    </Tag>
  );
}
